/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-14 20:38:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-04-19 10:38:02
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ResponsiveSubscription/index.tsx
 */
import React from 'react';
//import css from './css.module.less';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import _ResponsiveSub from 'src/components/Modules/ResponsiveSubscription';
import ContentGroupHOC from '../HOC';
import { compose } from 'redux';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { EnumFieldType } from 'src/types/common/customerDb';

const Subscription = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnItemDeleteAll,
    handleOnReselect,
    handleOnStaticsChange,
    specificError,
    droppableId,
    draggableId,
    extraProps,
    linkSet,
  } = props || {};
  const { breakpoint } = extraProps || {};
  const {
    tc,
    fields: customerFields,
    buttons,
    animations,
    hoverAnimations,
  } = React.useContext(ContentModuleGroupPreloadingContext);
  const _f = (customerFields || []).filter(
    (i) => i.fieldType !== EnumFieldType.AreaCodeMobileNumber,
  );
  const { fields, tacs } = dynamicData;

  const renderBody = () => {
    return (
      <_ResponsiveSub
        tcsOptions={tc}
        specificError={specificError}
        fields={fields}
        tacs={tacs}
        buttons={buttons}
        animations={animations}
        hoverAnimations={hoverAnimations}
        fieldsOptions={_f}
        draggableId={draggableId}
        staticData={staticData}
        droppableId={droppableId}
        onItemDelete={handleOnItemDelete}
        onItemAdd={handleItemOnAdd}
        onItemChange={handleItemOnChange}
        onItemSort={handleItemOnSort}
        onStaticChange={handleOnStaticsChange}
        onItemDeleteAll={handleOnItemDeleteAll}
        onItemReselect={handleOnReselect}
        breakpoint={breakpoint}
        linkSet={linkSet}
      />
    );
  };

  return renderBody();
};
export default compose(DataHOC, ContentGroupHOC)(Subscription);
